module.exports = __webpack_public_path__ + "static/media/8-hybrid.8946066e.png";